import { render, staticRenderFns } from "./Sortable.vue?vue&type=template&id=d6f8d33a"
import script from "./Sortable.vue?vue&type=script&lang=js"
export * from "./Sortable.vue?vue&type=script&lang=js"
import style0 from "./Sortable.vue?vue&type=style&index=0&id=d6f8d33a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports